import React from 'react'
import { ListingsHeader } from 'scripts/helpers/ListingsHeader'
import Thumbnail from 'scripts/components/thumbnail/Thumbnail'
import Metas from './Metas'
import {LoadMoreButton} from 'scripts/helpers/AppHelper'
import Loading from 'scripts/components/static/Loading'
import NotFound from 'scripts/components/notfound'
import locale from 'shared/i18n/react'
import TakeoverAd from 'scripts/components/TakeoverAd'

const RenderListings = (props) => {
  const {pageName, name, match, posts, pageTitle, clickLoadMore, ssr, btnclicked, hasError, loading, hasMore, sortItems} = props
  if (hasError) { return [<NotFound key={0} />] }
  if (ssr && !posts) { return [<Metas key={0} {...props}/>, <Loading key={1} />] }
  if (loading) { return [<Loading key={1} />] }
  if (!posts) { return [<div key={0} className={`${pageName}`}></div>] }

  return (
    <div className={`${pageName}`}>
      <TakeoverAd />
      <Metas {...props} />
      <div className="listing-header">
        <div className="container-main container container-full-bleed pos-relative">
          <div className="row">
            <div className="col small-12">
              <ListingsHeader name={name} routes={match || {}} />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        {sortItems}
      </div>
      <div className="section">
        <div className="container listing-items">
          <Thumbnail
            data={posts}
            title={pageTitle}
            titleArrow={false}
            size={4}
            titleDate={true}
            section="article_listing"
            showMeta={false}
          />
          <div className="section">
            {hasMore && <LoadMoreButton callback={clickLoadMore} text={locale.buttons.loadMore} status={btnclicked} />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RenderListings



// WEBPACK FOOTER //
// ./assets/js/components/listings/RenderListings.jsx